import { UserIncentivizedRewardsDto } from '../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import appContext from '../../../context/app/appContext';
import { getIncentivizeEarningsTotal } from '../../../helpers/sdkHelper';
import { sleep } from '../../../web3/utils';

const INCENTIVIZED_REWARDS_FAKE_TOKENS = ['0xece2b4cb29cf6ee46f52cbdcc17890f60b6bbf07'];

const useIncentivizedEarnings = () => {
    const { account } = useWeb3React();

    const { sdk } = useContext(appContext);

    const { mutate: globalMutate } = useSWRConfig();

    const { data, error, mutate } = useSWR(
        sdk && account ? ['incentivizedEarnings', account] : null,
        async (_, userAddress) => {
            const rewards = await sdk!.spools.getAggregatedUserRewardTokens(userAddress!);
            return rewards.filter(
                (reward) =>
                    !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
                        (reward.token.id as string).toLowerCase()
                    )
            );
        }
    );

    const update = async (previousValue?: UserIncentivizedRewardsDto[]) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (!currentValue) return;

            const currentTotal = getIncentivizeEarningsTotal(currentValue);
            const previousTotal = getIncentivizeEarningsTotal(previousValue);

            if (!previousTotal.eq(currentTotal)) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);

        //   when incentivizedEarnings is updated, mutate all spools.
        globalMutate(['userSpools', account]);
        globalMutate(['availableSpools', account]);
    };

    return {
        incentivizedEarnings: data,
        isLoading: !error && !data,
        error,
        updateIncentivizedEarnings: update,
    };
};

export default useIncentivizedEarnings;
